(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-info-drawer"] && !Shopify.designMode) return;
  try {
    class DeliveryInfoDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.triggerButtons = document.querySelectorAll('delivery-drawer-button');
    this.closeButton = this.querySelector('.delivery-info-drawer__close');
    this.initEventListeners();
  }

  initEventListeners() {
    this.triggerButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.toggleDrawer();
      });
    });

    // Close drawer when clicking on backdrop
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.toggleDrawer();
      }
    });

    // Close drawer when clicking on close button
    this.closeButton.addEventListener('click', () => {
      this.toggleDrawer();
    });

    // close on ESC key press if drawer is open
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('active')) {
        this.toggleDrawer();
      }
    });
  }
  toggleDrawer() {
    this.classList.toggle('active');
  }
}

customElements.define('delivery-info-drawer', DeliveryInfoDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-link-with-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-links-with-tabs')) {
    customElements.define('image-links-with-tabs', class ImageLinksWithTabs extends HTMLElement {
      constructor() {
        super();

      }

        connectedCallback() {
          const tabList = this.querySelector('.image-links-with-tabs__tab-list');
          if (!tabList || tabList.children.length === 1) return;

          const tabs = this.querySelectorAll('images-tab');
          const groups = this.querySelectorAll('images-group');

          tabList.addEventListener('click', (event) => {
            const clickedTab = event.target.closest('images-tab');
            if (!clickedTab) return;

            const targetGroupTitle = clickedTab.dataset.groupTitle;
            const targetGroup = this.querySelector(`images-group[data-group-title="${targetGroupTitle}"]`);
            if (!targetGroup) return;

            // Deactivate all tabs and hide all groups
            tabs.forEach(tab => tab.removeAttribute('active'));
            groups.forEach(group => group.setAttribute('hidden', ''));

            // Activate the clicked tab and show the corresponding group
            clickedTab.setAttribute('active', '');
            targetGroup.removeAttribute('hidden');

          });
        }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-personalisation')) {
    customElements.define(
      'product-personalisation',
      class ProductPersonalisation extends HTMLElement {
        constructor() {
          super();

          this.characterInputs = Array.from(
            this.querySelectorAll('[data-js-character-input] input')
          );
          this.placements = Array.from(this.querySelectorAll('[data-js-placement]'));
          this.placementButtons = Array.from(
            this.querySelectorAll('[data-js-placement-option]')
          );
          this.previewImage = this.querySelector('[data-js-preview-image]');
          this.countElement = this.querySelector('[data-js-character-count] .count');
          this.fontButtons = Array.from(this.querySelectorAll('[data-js-font]'));
          this.colourButtons = Array.from(this.querySelectorAll('[data-js-colour]'));
          this.activeColourElement = this.querySelector('[data-js-active-colour]');
          this.cart = document.querySelector('cart-drawer');
          this.addBothButton = this.querySelector('[data-js-add-both-to-cart]');
          this.cartMessageElement = this.querySelector('[data-js-cart-message]');

          this.mainSectionId = this.dataset.mainSectionId;
          this.personalisationVariantId = this.dataset.personalisationVariantId;
          this.cartLineIndex = Number(this.dataset.cartLineIndex || 0);
          this.cartLineVariantId = String(this.dataset.cartLineVariantId || '');
          this.cartLineQuantity = Number(this.dataset.cartLineQuantity || 1);
          this.cartLineProperties = this.parseJsonData(this.dataset.cartLineProperties);

          this.defaultColourButtonIndex = Math.max(
            this.colourButtons.findIndex((button) => button.classList.contains('active')),
            0
          );
          this.defaultFontButtonIndex = Math.max(
            this.fontButtons.findIndex((button) => button.classList.contains('active')),
            0
          );
          this.defaultPlacementButtonIndex = Math.max(
            this.placementButtons.findIndex((button) => button.classList.contains('active')),
            0
          );

          this._boundAddBothToCart = this.handleAddBothToCart.bind(this);
          this._characterInputHandlers = [];
          this._placementButtonHandlers = [];
          this._colourButtonHandlers = [];
          this._fontButtonHandlers = [];
          this._modalObserver = null;
        }

        connectedCallback() {
          this.bindCharacterInputs();
          this.bindColourButtons();
          this.bindFontButtons();
          this.bindPlacementButtons();

          if (this.addBothButton) {
            this.addBothButton.addEventListener('click', this._boundAddBothToCart);
          }

          this.observeModalClose();
          this.updatePersonalisationPreview();
        }

        disconnectedCallback() {
          this._characterInputHandlers.forEach(({ input, inputHandler, beforeinputHandler }) => {
            input.removeEventListener('input', inputHandler);
            input.removeEventListener('beforeinput', beforeinputHandler);
          });
          this._characterInputHandlers = [];

          this._placementButtonHandlers.forEach(({ button, handler }) => {
            button.removeEventListener('click', handler);
          });
          this._placementButtonHandlers = [];

          this._colourButtonHandlers.forEach(({ button, handler }) => {
            button.removeEventListener('click', handler);
          });
          this._colourButtonHandlers = [];

          this._fontButtonHandlers.forEach(({ button, handler }) => {
            button.removeEventListener('click', handler);
          });
          this._fontButtonHandlers = [];

          if (this.addBothButton) {
            this.addBothButton.removeEventListener('click', this._boundAddBothToCart);
          }

          if (this._modalObserver) {
            this._modalObserver.disconnect();
            this._modalObserver = null;
          }
        }

        parseJsonData(value) {
          if (!value) return {};

          try {
            const parsed = JSON.parse(value);
            return parsed && typeof parsed === 'object' ? parsed : {};
          } catch {
            return {};
          }
        }

        sanitizeCharacter(value) {
          return value.replace(/[^A-Za-z0-9]/g, '').slice(0, 1).toUpperCase();
        }

        isCartPersonalisationFlow() {
          return Boolean(this.cartLineIndex && this.cartLineVariantId);
        }

        getSelectedText() {
          return this.characterInputs.map((input) => input.value).join('');
        }

        getActiveButton(buttons) {
          return buttons.find((button) => button.classList.contains('active')) || buttons[0] || null;
        }

        setActiveButton(buttons, target) {
          buttons.forEach((button) => button.classList.remove('active'));
          if (target) target.classList.add('active');
        }

        setAddButtonEnabled(enabled) {
          if (!this.addBothButton) return;

          if (enabled) {
            this.addBothButton.removeAttribute('aria-disabled');
            this.addBothButton.removeAttribute('disabled');
          } else {
            this.addBothButton.setAttribute('aria-disabled', 'true');
            this.addBothButton.setAttribute('disabled', 'true');
          }
        }

        setAddButtonLoading(loading) {
          if (!this.addBothButton) return;
          this.addBothButton.classList.toggle('loading', loading);
        }

        updateCartMessage(message) {
          if (!this.cartMessageElement) return;
          this.cartMessageElement.textContent = message;
          this.cartMessageElement.hidden = !message;
        }

        bindCharacterInputs() {
          this.characterInputs.forEach((input, index) => {
            const inputHandler = () => {
              input.value = this.sanitizeCharacter(input.value);
              if (input.value && index < this.characterInputs.length - 1) {
                this.characterInputs[index + 1].focus();
              }
              this.updatePersonalisationPreview();
              this.updateCartMessage('');
            };

            const beforeinputHandler = (event) => {
              if (event.inputType !== 'insertText' || !event.data) return;
              if (!/^[A-Za-z0-9]$/.test(event.data)) {
                event.preventDefault();
              }
            };

            input.addEventListener('input', inputHandler);
            input.addEventListener('beforeinput', beforeinputHandler);
            this._characterInputHandlers.push({ input, inputHandler, beforeinputHandler });
          });
        }

        bindColourButtons() {
          this.colourButtons.forEach((button) => {
            const handler = () => {
              this.setActiveButton(this.colourButtons, button);
              this.updatePlacementColour(button.dataset.jsColour, button.dataset.jsColourName);
              this.updateCartMessage('');
            };
            button.addEventListener('click', handler);
            this._colourButtonHandlers.push({ button, handler });
          });

          const active = this.getActiveButton(this.colourButtons);
          if (active) {
            this.setActiveButton(this.colourButtons, active);
            this.updatePlacementColour(active.dataset.jsColour, active.dataset.jsColourName);
          }
        }

        bindFontButtons() {
          this.fontButtons.forEach((button) => {
            const handler = () => {
              this.setActiveButton(this.fontButtons, button);
              this.updatePlacementFont(button.dataset.jsFont);
              this.updateCartMessage('');
            };
            button.addEventListener('click', handler);
            this._fontButtonHandlers.push({ button, handler });
          });

          const active = this.getActiveButton(this.fontButtons);
          if (active) {
            this.setActiveButton(this.fontButtons, active);
            this.updatePlacementFont(active.dataset.jsFont);
          }
        }

        bindPlacementButtons() {
          this.placementButtons.forEach((button) => {
            const handler = () => {
              this.setActiveButton(this.placementButtons, button);
              this.applyPlacementOption(button);
            };
            button.addEventListener('click', handler);
            this._placementButtonHandlers.push({ button, handler });
          });

          const active = this.getActiveButton(this.placementButtons);
          if (active) {
            this.setActiveButton(this.placementButtons, active);
            this.applyPlacementOption(active);
          }
        }

        observeModalClose() {
          const modal = this.closest('modal-dialog');
          if (!modal) return;

          this._modalObserver = new MutationObserver(() => {
            if (!modal.hasAttribute('open')) {
              this.resetPersonalisationForm();
            }
          });

          this._modalObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
        }

        updatePersonalisationPreview() {
          const value = this.getSelectedText();
          const count = this.characterInputs.reduce(
            (total, input) => total + (input.value ? 1 : 0),
            0
          );

          this.placements.forEach((placement) => {
            placement.textContent = value;
          });

          if (this.countElement) {
            this.countElement.textContent = String(count);
          }

          this.setAddButtonEnabled(value.length > 0);
        }

        updatePlacementColour(colour, colourName) {
          if (!colour) return;

          this.placements.forEach((placement) => {
            placement.style.color = colour;
          });

          if (this.activeColourElement && colourName) {
            this.activeColourElement.textContent = colourName;
          }
        }

        updatePlacementFont(fontName) {
          if (!fontName) return;

          this.placements.forEach((placement) => {
            placement.style.fontFamily = fontName;
          });
        }

        updatePlacementCoordinates(topDesktop, leftDesktop, topMobile, leftMobile) {
          if (!topDesktop || !leftDesktop) return;

          this.placements.forEach((placement) => {
            placement.style.setProperty('--placement-top-desktop', topDesktop);
            placement.style.setProperty('--placement-left-desktop', leftDesktop);
            placement.style.setProperty('--placement-top-mobile', topMobile || topDesktop);
            placement.style.setProperty('--placement-left-mobile', leftMobile || leftDesktop);
          });
        }

        updatePreviewImage(previewImageUrl) {
          if (this.previewImage && previewImageUrl) {
            this.previewImage.src = previewImageUrl;
          }
        }

        applyPlacementOption(button) {
          if (!button) return;

          this.updatePlacementCoordinates(
            button.dataset.jsPlacementTopDesktop,
            button.dataset.jsPlacementLeftDesktop,
            button.dataset.jsPlacementTopMobile,
            button.dataset.jsPlacementLeftMobile
          );
          this.updatePreviewImage(button.dataset.jsPreviewImage);
        }

        resetPersonalisationForm() {
          this.characterInputs.forEach((input) => {
            input.value = '';
          });

          const defaultColourButton =
            this.colourButtons[this.defaultColourButtonIndex] || this.colourButtons[0];
          if (defaultColourButton) {
            this.setActiveButton(this.colourButtons, defaultColourButton);
            this.updatePlacementColour(
              defaultColourButton.dataset.jsColour,
              defaultColourButton.dataset.jsColourName
            );
          }

          const defaultFontButton =
            this.fontButtons[this.defaultFontButtonIndex] || this.fontButtons[0];
          if (defaultFontButton) {
            this.setActiveButton(this.fontButtons, defaultFontButton);
            this.updatePlacementFont(defaultFontButton.dataset.jsFont);
          }

          const defaultPlacementButton =
            this.placementButtons[this.defaultPlacementButtonIndex] || this.placementButtons[0];
          if (defaultPlacementButton) {
            this.setActiveButton(this.placementButtons, defaultPlacementButton);
            this.applyPlacementOption(defaultPlacementButton);
          }

          this.updateCartMessage('');
          this.updatePersonalisationPreview();
        }

        getMainProductForm() {
          if (this.mainSectionId) {
            const form = document.querySelector(`#product-form-${this.mainSectionId}`);
            if (form) return form;
          }

          return (
            this.closest('section')?.querySelector('form[action*="/cart/add"]') ||
            document.querySelector('form[action*="/cart/add"]')
          );
        }

        async getLiveCartLine() {
          const response = await fetch('/cart.js');
          const cartData = await response.json();

          const lineByIndex = cartData.items[this.cartLineIndex - 1];
          if (lineByIndex && String(lineByIndex.variant_id) === String(this.cartLineVariantId)) {
            return lineByIndex;
          }

          return (
            cartData.items.find(
              (item) => String(item.variant_id) === String(this.cartLineVariantId)
            ) || null
          );
        }

        createPairingKey(mainVariantId) {
          return `${String(mainVariantId)}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        }

        async handleAddBothToCart() {
          const selectedText = this.getSelectedText();
          if (!selectedText.length) {
            this.updateCartMessage('Please enter at least one character for personalisation.');
            this.setAddButtonEnabled(false);
            this.characterInputs[0]?.focus();
            return;
          }

          const activeColourButton = this.getActiveButton(this.colourButtons);
          const activeFontButton = this.getActiveButton(this.fontButtons);
          const selectedColour =
            activeColourButton?.dataset.jsColourName || activeColourButton?.dataset.jsColour || '';
          const selectedFont =
            activeFontButton?.textContent?.trim() || activeFontButton?.dataset.jsFont || '';

          let mainVariantId = '';
          let mainQuantity = 1;
          let baseProperties = {};

          if (this.isCartPersonalisationFlow()) {
            const liveCartLine = await this.getLiveCartLine();

            if (!liveCartLine) {
              this.updateCartMessage('Unable to find the cart item to personalise.');
              return;
            }

            mainVariantId = String(liveCartLine.variant_id);
            mainQuantity = 1;
            baseProperties = this.cartLineProperties || {};

            if (liveCartLine.quantity <= 0) {
              this.updateCartMessage('Unable to add items to cart right now. Please try again.');
              return;
            }
          } else {
            const form = this.getMainProductForm();
            mainVariantId = form?.querySelector('input[name="id"]')?.value || '';
            mainQuantity = Number(form?.querySelector('input[name="quantity"]')?.value || 1);
          }

          const personalisationVariantId = this.personalisationVariantId;

          if (!mainVariantId || !personalisationVariantId) {
            this.updateCartMessage('Unable to add items to cart right now. Please try again.');
            return;
          }

          this.updateCartMessage('');
          this.setAddButtonEnabled(false);
          this.setAddButtonLoading(true);

          const pairingKey = this.createPairingKey(mainVariantId);
          const mainLineProperties = {
            ...(baseProperties || {}),
            Text: selectedText,
            'Text Colour': selectedColour,
            Font: selectedFont,
            _personalisation: 'true',
            _pairing_key: pairingKey,
          };

          const payloadQuantity = this.isCartPersonalisationFlow() ? 1 : mainQuantity;

          const payload = {
            items: [
              {
                id: Number(mainVariantId),
                quantity: payloadQuantity,
                properties: mainLineProperties,
              },
              {
                id: Number(personalisationVariantId),
                quantity: payloadQuantity,
                properties: {
                  _paired_variant: String(mainVariantId),
                  _pairing_key: pairingKey,
                },
              },
            ],
          };

          if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          try {
            if (this.isCartPersonalisationFlow()) {
              const liveCartLine = await this.getLiveCartLine();
              if (!liveCartLine) {
                this.updateCartMessage('Unable to find the cart item to personalise.');
                return;
              }

              const changeConfig = fetchConfig('javascript');
              changeConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              changeConfig.body = JSON.stringify({
                line: this.cartLineIndex,
                quantity: Math.max(0, Number(liveCartLine.quantity) - 1),
              });

              const changeResponse = await fetch(routes.cart_change_url, changeConfig);
              const changeData = await changeResponse.json();

              if (changeData.status || changeData.errors || !changeResponse.ok) {
                this.updateCartMessage(changeData.description || 'Unable to add items to cart right now.');
                return;
              }
            }

            const addConfig = fetchConfig('javascript');
            addConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            addConfig.body = JSON.stringify(payload);

            const response = await fetch(routes.cart_add_url, addConfig);
            const data = await response.json();

            if (data.status || !response.ok) {
              this.updateCartMessage(data.description || 'Unable to add items to cart right now.');
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-personalisation',
                productVariantId: mainVariantId,
              });
              publish(PUB_SUB_EVENTS.cartChange, { source: 'product-personalisation' });
            }

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(data);
            } else {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.classList.add('drawer', 'animate', 'active');
              }
            }

            this.resetPersonalisationForm();

            const modal = this.closest('modal-dialog');
            if (modal && typeof modal.hide === 'function') {
              setTimeout(() => modal.hide());
            }
          } catch (error) {
            console.error(error);
            this.updateCartMessage('Unable to add items to cart right now.');
          } finally {
            this.setAddButtonLoading(false);
            this.setAddButtonEnabled(this.getSelectedText().length > 0);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-locator-drawer"] && !Shopify.designMode) return;
  try {
    class StoreLocatorDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.triggerButtons = document.querySelectorAll('store-locator-button');
    this.closeButton = this.querySelector('.store-locator-drawer__close');
    this.initEventListeners();
  }

  initEventListeners() {
    this.triggerButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.toggleDrawer();
      });
    });

    // Close drawer when clicking on backdrop
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.toggleDrawer();
      }
    });

    // Close drawer when clicking on close button
    this.closeButton.addEventListener('click', () => {
      this.toggleDrawer();
    });

    // close on ESC key press if drawer is open
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('active')) {
        this.toggleDrawer();
      }
    });
  }
  toggleDrawer() {
    this.classList.toggle('active');
  }
}

customElements.define('store-locator-drawer', StoreLocatorDrawer);
  } catch(e) { console.error(e); }
})();

})();
